@let control = ngControl.control;

<mat-form-field appearance="outline" class="rp-input textarea" [class.filled]="control.value" [subscriptSizing]="subscriptSizing()">
  <mat-label>{{ label() }}</mat-label>

  <textarea
    matInput
    cdkTextareaAutosize
    #textareaAutosize="cdkTextareaAutosize"
    [formControl]="control"
    [placeholder]="placeholder()"
    [errorStateMatcher]="matcher()"
    [cdkAutosizeMinRows]="rows()"
    [cdkAutosizeMaxRows]="maxRows()"
  >
  </textarea>

  @if (hint()) {
    <mat-hint mat-hint>{{ hint() }}</mat-hint>
  }

  @if ((control.invalid || (control.dirty && errors().length)) && showErrorMessage()) {
    <mat-error>{{ firstError() | translate: firstErrorKey() }}</mat-error>
  }
</mat-form-field>
